import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import DropDownOA from '../../../common/dropDownOA'
import { focusElemnt, getFloat, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { standardRateHistoryDataDummy } from './dummyConstans'
import { cargoServiceTypes, standardMatrixObj, standardRateHead, standarRateChrgOpt, standarRateOthChrgOpt } from './rateMatrixConstants'
import StandardRateMatrixHistory from './standardRateMatrixHistory'
import { updateAlertError, updateModal } from '../../../../store/common/common_action'
import { getFocApprConsTypeData, getRateMatrixData, getServiceTypeListAllData, updateRateMatrixUpdate } from '../../../../store/generalSetting/GSAction'
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal'
import LineinputV2 from '../../../common/lineinputV2'

const StandardRateMatrix = (props) => {
  const { data, updateModal, updateAlertError, getFocApprConsTypeData, getRateMatrixData, updateRateMatrixUpdate, getServiceTypeListAllData } = props
  const { common, generalSettingReducer } = data
  const { loginData, showModal, modalType } = common
  const { focApprConsTypeData, serviceTypeListAll, serviceTypeListAll2 } = generalSettingReducer
  const [selectedServiceType, setSelectedServiceType] = useState(cargoServiceTypes[0])
  const [filterOpt, setFilterOpt] = useState({
    consType: [],
    CargoServiceType: [],
    chrgType: standarRateChrgOpt
  })
  const [filterValue, setFilterValue] = useState({
    consType: '',
    CargoServiceType: ''
  })
  const [isSave, setIsSave] = useState(false)
  const [showTable, setShowTable] = useState(false)
  const [tableData, setTableData] = useState([])
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let obj = {
        intConsignmentSubTypeID: 0,
        intCompanyID: loginData?.intCompanyID,
        intConsignmentTypeID: 0,
        strSubType: "",
        intIsActive: 1,
        intIsDeleted: 0
      }
      getFocApprConsTypeData(obj, true, 24 * 60 * 60 * 1000)
    }
  }, [loginData])
  useEffect(() => {
    if (serviceTypeListAll?.length > 0) {
      let data = serviceTypeListAll?.filter((val) => serviceTypeListAll2?.length > 0 ? serviceTypeListAll2?.[0]?.CargoServiceTypeID === 0 ? val?.ServiceTypeID === 2 : true : true)
      if (Number(serviceTypeListAll2?.[0]?.CargoServiceTypeID) === 1) {
        data.unshift({ ServiceTypeID: 0, ServiceType: 'All' })
        setSelectedServiceType(cargoServiceTypes[1])
      } else {
        setSelectedServiceType(cargoServiceTypes[0])
      }
      setFilterOpt((prev) => ({
        ...prev,
        CargoServiceType: data
      }))
      setFilterValue((prev) => ({
        ...prev,
        CargoServiceType: data[0]
      }))
    } else {
      setFilterOpt((prev) => ({
        ...prev,
        CargoServiceType: []
      }))
      setFilterValue((prev) => ({
        ...prev,
        CargoServiceType: []
      }))
    }
  }, [serviceTypeListAll, serviceTypeListAll2])
  useEffect(() => {
    if (focApprConsTypeData?.length > 0) {
      let newData = []
      focApprConsTypeData.map(function (obj) {
        newData.push({
          ...obj,
          id: obj.ConsignmentSubTypeID,
          name: obj.SubType,
        })
      })
      newData = removeDuplicatesFromArray(newData, `id`)
      newData.sort((a, b) => a.name.localeCompare(b.name))
      let defConsType = newData[0]
      setFilterValue((prev) => ({
        ...prev,
        consType: newData[0]
      }))
      let defChrg = standarRateChrgOpt?.filter((obj) => {
        if (defConsType?.BillingUnit === 1 && defConsType?.IsKgKm === 1) {
          return [1, 4]?.includes(obj?.id)
        } else if (defConsType?.BillingUnit === 1 && defConsType?.IsKgKm === 0) {
          return [1]?.includes(obj?.id)
        } else {
          return [2]?.includes(obj?.id)
        }
      })
      setFilterOpt((prev) => ({
        ...prev,
        consType: newData,
        chrgType: defChrg
      }))
    } else {
      setFilterOpt((prev) => ({
        ...prev,
        consType: []
      }))
      setFilterValue((prev) => ({
        ...prev,
        consType: []
      }))
    }
    resetValue()
  }, [focApprConsTypeData, serviceTypeListAll])
  const resetValue = () => {
    setShowTable(false)
    setTableData([])
  }
  const handleLoadBtn = () => {
    resetValue()
    if (filterValue?.CargoServiceType === '') {
      updateAlertError({ show: true, msg: 'Please Select Multi Cargo Service Type', success: false, nextId: `` })
    } else if (filterValue?.consType === '') {
      updateAlertError({ show: true, msg: 'Please Select Consignment Type', success: false, nextId: `` })
    } else {
      const body = {
        CompanyID: loginData?.intCompanyID,
        ServiceTypeID: filterValue?.CargoServiceType?.ServiceTypeID,
        ConsignmentID: filterValue?.consType?.id,
        MopID: 0,
      }
      getRateMatrixData(body).then((res) => {
        if (res.status === 'Success') {
          let data = res?.Data?.Table
          if (filterValue?.CargoServiceType?.ServiceTypeID === 0) {
            handleChrgDefValue(filterOpt?.CargoServiceType?.filter((val) => val.ServiceTypeID !== 0), data)
          } else {
            handleChrgDefValue([filterValue?.CargoServiceType], data)
          }
        } else {
          updateAlertError({ show: true, msg: 'No Data', nextId: '' })
        }
      }).catch((error) => {
        updateAlertError({ show: true, msg: error, nextId: '' })
      })
    }
  }

  const handleChrgDefValue = (CargoServiceType = [], data = []) => {
    let newData = []
    CargoServiceType.forEach((obj) => {
      let findService = data.filter((val) => Number(val?.ServiceTypeID) === Number(obj?.ServiceTypeID))
      if (findService?.length === 0) {
        newData.push({
          ...standardMatrixObj,
          ServiceTypeID: Number(obj?.ServiceTypeID),
          ServiceType: obj?.ServiceType
        })
      } else {
        findService.forEach((val) => {
          let chrgObj = { ...val }
          Object.keys(val).forEach((key) => {
            if (['FreightBillUnits', 'CollCartBillUnits', 'CartDelBillUnits', 'DocChgBillUnits', 'HamBillUnits', 'OptHamBillUnits', 'PickupChgBillUnits', 'DropoffChgBillUnits', 'ValBillUnits', 'ConvFeeBillUnits', 'DelHamBillUnits', 'DelOpHamBillUnits', 'DelCartBillUnits', 'DemurrageBillUnits'].includes(key)) {
              let defValue = (key === 'FreightBillUnits' ? filterOpt?.chrgType : standarRateOthChrgOpt)?.filter((obj) => obj.id === val[key])?.[0]?.id || 0
              chrgObj[key] = defValue
            }
          });
          newData.push(chrgObj)
        })
      }
    })
    setTableData(newData.sort((a, b) => a.ServiceTypeID - b.ServiceTypeID))
    setShowTable(true)
  }
  const handleCharge = (index, field, value) => {
    const newData = [...tableData]
    newData[index][field] = value
    setTableData(newData)
  }
  const CustomTableCell = (props) => {
    const { data, index, field, dataDropDown, fieldDropDown, tableData, colIndex } = props
    let defValue = (fieldDropDown === 'FreightBillUnit' ? filterOpt?.chrgType : standarRateOthChrgOpt)?.filter((obj) => obj.id === dataDropDown)?.[0]?.name || ''
    return (
      <div className='standard-rate-dropdown'>
        <DropDownOA
          data={fieldDropDown === 'FreightBillUnit' ? filterOpt?.chrgType : standarRateOthChrgOpt}
          defaultvalue={defValue}
          idKey={`id`}
          id={`dropDown-${index}-${colIndex}`}
          dataKey={`name`}
          nextId={colIndex === 14 ? `input-${index}-${1}` : `dropDown-${index}-${colIndex + 1}`}
          prevId={index === 0 && colIndex === 1 ? 'save_btnRateMatrix' : colIndex === 1 ? `input-${index - 1}-${14}` : `dropDown-${index}-${colIndex - 1}`}
          width={'100%'}
          noCross={false}
          listWidth='250px'
          onSelect={(val) => {
            const newData = [...tableData]
            newData[index][fieldDropDown] = val?.id || 0
            setTableData(newData)
          }}
          onReset={() => {
            const newData = [...tableData]
            newData[index][fieldDropDown] = 0
            newData[index][field] = 0
            setTableData(newData)
          }}
          portal={true}
        />
        <div className="input--wrapper">
          <LineinputV2
            id={`input-${index}-${colIndex}`}
            value={data}
            name="chrg_value"
            type="text"
            filter={getFloat}
            onBlur={(event) => {
              handleCharge(index, field, event.target.value)
              if (event.key === 'Enter') {
                setTimeout(() => {
                  focusElemnt((colIndex === 14 && tableData.length - 1 === index) ? 'Service_Type' : colIndex === 14 ? `dropDown-${index + 1}-${1}` : `input-${index}-${colIndex + 1}`)
                }, 0)
              } else if (event.key === 'Escape') {
                setTimeout(() => {
                  focusElemnt(colIndex === 1 ? `dropDown-${index}-${14}` : `input-${index}-${colIndex - 1}`)
                }, 0)
              }
            }}
          />
        </div>
      </div>
    )
  }
  const showStandardHistoryPopup = () => {
    const data = {
      loginData,
      isUpdate: true,
      headText: 'Standard Rate Matrix History',
      branchAndCityOpt: '',
      listData: standardRateHistoryDataDummy,
    }
    const methods = {
      updateModal,
      // updateAlertError,
    }
    return <StandardRateMatrixHistory data={data} methods={methods} />
  }
  const transferArrToObject = (arr) => {
    const newObject = arr.reduce((result, obj) => {
      Object.keys(obj).forEach(key => {
        result[key] = result[key] ? `${result[key]}^${obj[key]}` : `${obj[key]}`;
      });
      return result;
    }, {});
    return newObject
  }
  const handleSaveRate = () => {
    let tableDataObj = transferArrToObject(tableData)
    const body = {
      CompanyID: loginData?.intCompanyID,
      ConsignmentID: filterValue?.consType?.id,
      MopID: 0,
      ServiceTypeIDs: tableDataObj?.ServiceTypeID || '',
      FreightBillUnits: tableDataObj?.FreightBillUnit || '',
      Freight: tableDataObj?.Freight || '',
      CollCartBillUnits: tableDataObj?.CollCartageBillUnit || '',
      CollCartage: tableDataObj?.CollCartage || '',
      CartDelBillUnits: tableDataObj?.CartageDelBillUnit || '',
      CartageDel: tableDataObj?.CartageDel || '',
      DocChgBillUnits: tableDataObj?.DocChgBillUnit || '',
      DocChg: tableDataObj?.DocChg || '',
      HamBillUnits: tableDataObj?.HamaliChgBillUnit || '',
      HamChg: tableDataObj?.HamaliChg || '',
      OptHamBillUnits: tableDataObj?.OptHamChgBillUnit || '',
      OptHamChg: tableDataObj?.OptHamChg || '',
      PickupChgBillUnits: tableDataObj?.PickupChgBillUnit || '',
      PickupChg: tableDataObj?.PickupChg || '',
      DropoffChgBillUnits: tableDataObj?.DropoffChgBillUnit || '',
      DropoffChg: tableDataObj?.DropoffChg || '',
      ValBillUnits: tableDataObj?.ValuationBillUnit || '',
      Valuation: tableDataObj?.ValuationChg || '',
      ConvFeeBillUnits: tableDataObj?.ConvFeeBillUnit || '',
      ConvFee: tableDataObj?.ConvFee || '',
      DelHamBillUnits: tableDataObj?.DelHamChgBillUnit || '',
      DelHamChg: tableDataObj?.DelHamChg || '',
      DelOpHamBillUnits: tableDataObj?.DelOptHamBillUnit || '',
      DelOpHamChg: tableDataObj?.DelOptHamChg || '',
      DelCartBillUnits: tableDataObj?.DelCartageBillUnit || '',
      DelCartChg: tableDataObj?.DelCartageChg || '',
      DemurrageBillUnits: tableDataObj?.DemurrageBillUnit || '',
      Demurrage: tableDataObj?.DemurrageChg || ''
    }
    updateRateMatrixUpdate(body).then((res) => {
      if (res?.status === 'Success') {
        setIsSave(true)
      } else {
        updateAlertError({ show: true, msg: res.Message, success: false, nextId: `` })
      }

    })
  }
  const handleCloseSuccessModal = () => {
    handleLoadBtn()
    setIsSave(false)
  }
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', margin: '10px 0' }}>
        <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap' }} className="reportButtons">
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'Cargo_Service_Type'}
              label={'Cargo Service Type'}
              data={cargoServiceTypes}
              defaultvalue={selectedServiceType.name}
              onSelect={(seviceType) => {
                setSelectedServiceType(seviceType)
                resetValue()
              }}
              idKey={`id`}
              dataKey={`name`}
              width={'250px'}
              nextId={``}
              prevId={``}
              disabled={true}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id='Service_Type'
              label={'Select Service Type'}
              data={filterOpt?.CargoServiceType || []}
              defaultvalue={filterValue?.CargoServiceType?.ServiceType || ''}
              value={filterValue?.CargoServiceType?.ServiceType || ''}
              idKey={`ServiceTypeID`}
              dataKey={`ServiceType`}
              onSelect={(val) => {
                setFilterValue((prev) => ({
                  ...prev,
                  CargoServiceType: val
                }))
                resetValue()
              }}
              nextId={`cons_type`}
              width={'250px'}
              prevId={tableData?.length > 0 ? `input-${tableData?.length - 1}-${14}` : `search_btnRateMatrix`} />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id='cons_type'
              data={filterOpt?.consType || []}
              defaultvalue={filterValue?.consType?.name || ''}
              value={filterValue?.consType?.name || ''}
              label={'Consignment Type'}
              idKey={`id`}
              dataKey={`name`}
              nextId={`search_btnRateMatrix`}
              prevId={`Service_Type`}
              onSelect={(val) => {
                let defChrg = standarRateChrgOpt?.filter((obj) => {
                  if (val?.BillingUnit === 1 && val?.IsKgKm === 1) {
                    return [1, 4]?.includes(obj?.id)
                  } else if (val?.BillingUnit === 1 && val?.IsKgKm === 0) {
                    return [1]?.includes(obj?.id)
                  } else {
                    return [2]?.includes(obj?.id)
                  }
                })
                setFilterValue((prev) => ({
                  ...prev,
                  consType: val,
                }))
                setFilterOpt((prev) => ({
                  ...prev,
                  chrgType: defChrg
                }))
                resetValue()
              }}
              width={'250px'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="contained"
              onKeyDown={(e) => navigation3(e, tableData?.length === 0 ? 'Service_Type' : 'save_btnRateMatrix', 'cons_type', () => { })}
              id={'search_btnRateMatrix'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn btn-primary"
              onClick={() => handleLoadBtn()}
            >
              Load
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="outlined"
              onKeyDown={(e) => navigation3(e, 'Service_Type', 'search_btnRateMatrix', () => { })}
              id={'save_btnRateMatrix'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn cancel-btn"
              onClick={() => {
                handleSaveRate()
              }}
              disabled={tableData?.length === 0}
            >
              SAVE RATES
            </Button>
          </Item>
        </Box>
      </Box>
      <TableContainer component={Paper} className="scrollBlue" style={{
        marginBottom: '5px',
        overflowY: 'visible',
      }}>
        {showTable > 0 && (
          <Table
            stickyHeader
            size="small"
            aria-label="a dense table"
            sx={{
              '&.MuiTableCell-root': {
                padding: '6px 8px!important',
              },
            }}
          >
            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
              <TableRow>
                {standardRateHead.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    sx={{
                      ...col.headerSx,
                      backgroundColor: '#DAEDFE',
                      minHeight: '40px',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444',
                      padding: '8px 3px',
                      whiteSpace: 'pre-line'
                    }}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData.length > 0 && (
              <TableBody>
                {tableData.map((item, index) => (
                  <TableRow key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#f5f5f5', // Alternate colors
                    }}
                  >
                    {standardRateHead.map((col, index1) => (
                      //#F5FAFE
                      <>
                        {['ServiceType', 'ServiceTypeID']?.includes(col.field) ?
                          <TableCell key={`TC-${index1}`} sx={{ ...col.headerSx, padding: '6px 3px', fontSize: '12px', fontWeight: '600', color: 'rgba(0, 0, 0, 0.87)', backgroundColor: '#F5FAFE' }}>
                            {item[col.field]}
                          </TableCell> :
                          <TableCell key={`TC-${index1}`} sx={{
                            ...col.headerSx, padding: '6px 3px',
                            '.cross--icon': {
                              top: '1px !important',
                              right: '18px !important'
                            }
                          }}>
                            <CustomTableCell colIndex={index1} tableData={tableData} fieldDropDown={col.dropDown} dataDropDown={item[col.dropDown]} data={item[col.field]} field={col.field} index={index} />
                          </TableCell>
                        }
                      </>

                    ))}
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        )}
      </TableContainer>
      {showModal && 'standard_rate_history' === modalType ? showStandardHistoryPopup() : null}
      <SuccessAndErrorModal handleClose={() => { handleCloseSuccessModal() }} open={isSave} title={'New Rates Saved Successfully!'} modalStyle={modalStyle} />

    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, getFocApprConsTypeData, getRateMatrixData, updateAlertError, updateRateMatrixUpdate, getServiceTypeListAllData }
export default connect(mapStateToProps, mapDispatchToProps)(StandardRateMatrix)
